import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getSuppliers = async ({
  page = 1,
  limit = 25,
  search,
  categoryId,
  isActive,
  signal,
} = {}) => {
  const query = qs({ page, limit, search, categoryId, isActive });
  return httpClient.get(`/stock/suppliers${query}`, { signal });
};

export const getSupplierCategoryOptions = async ({ signal } = {}) => {
  return httpClient.get("/stock/ingredient-categories/options", { signal });
};

export const createSupplier = async (data) => {
  return httpClient.post("/stock/suppliers", data);
};

export const patchSupplier = async (supplierId, data) => {
  if (!supplierId) throw new Error("El ID del proveedor es requerido");
  return httpClient.patch(`/stock/suppliers/${supplierId}`, data);
};
